import axios from "../../interceptors/axiosInterceptor";
import { GET_PENDING_CUSTOMER_PROFILES_URL, GET_CNIC_IMAGE, VERIFY_CNIC } from "config/Url";
import {
  IFetchCnicVerificationActionResponse,
  ICnicVerification,
  ICnicImageActionResponse,
  ICnicVerificationRequestPayload,
} from "interfaces/Index";
import { normalizeCatchErrors } from "utils/errorUtils";
import { getAuthOptions } from "config/Headers";
import { IGetQueryParams } from "interfaces/Index";
import { SOMETHING_WENT_WRONG } from "config/constants";
export const getCnicImageApiCall = (
  queryParam: IGetQueryParams = {},
  imageId: string,
  imageType: string
) => {
  return new Promise<ICnicImageActionResponse>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    const url = `${GET_CNIC_IMAGE}/${imageType}/${imageId}`;
    axios
      .get(url, requestConfig)
      .then((response) => {
        if (response) {
          resolve(response?.data);
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};

export const getCnicVerificationDataApiCall = (
  queryParam: IGetQueryParams = {}
) => {
  return new Promise<IFetchCnicVerificationActionResponse>(
    (resolve, reject) => {
      let requestConfig: any = getAuthOptions();
      requestConfig.params = queryParam;
      axios
        .get(GET_PENDING_CUSTOMER_PROFILES_URL, requestConfig)
        .then((response) => {
          if (response) {
            const cnicVerificationData: ICnicVerification[] =
              response?.data || [];
            const pageNumber = queryParam.pageNo
              ? Number(queryParam.pageNo) + 1
              : 1;
            const pagination =
              cnicVerificationData.length === 50 ? pageNumber : false;
            const isPaginatedRes =
              queryParam.pageNo &&
              (queryParam.pageNo as any) > 0 &&
              cnicVerificationData.length >= 50
                ? true
                : false;
            resolve({
              cnicVerificationData,
              pagination,
              isPaginatedRes,
            });
          }
        })
        .catch((error) => {
          const errorPayload = normalizeCatchErrors(error.response);
          reject(errorPayload);
        });
    }
  );
};

export const verifyCnicDataApiCall = (
  payload: ICnicVerificationRequestPayload
) => {
  return new Promise<void>((resolve, reject) => {  
    let requestConfig: any = getAuthOptions();
    axios
      .patch(VERIFY_CNIC, payload, requestConfig)
      .then(() => {
        resolve();
      })
      .catch(() => {
        reject({ errors: SOMETHING_WENT_WRONG });
      });
  });
};
